import * as _ from 'lodash'
import { all, A, equal, not, or, reactive, VString, Mark } from 'alkali'
import app from 'app/app'
import Icon from '../Icon'
import * as deleteCircleIcon from 'icons/delete-1.svg'
import { Annotation, ENTITIES } from './model/Annotations'
import { termToString } from './model/DocSearch'

const AnnotationMark = Mark.with('.span.dre-ds-ann', {
	created(props) {
		const a: Annotation = props.annot
		const atype = new VString(a.type)
		const asource = new VString(a.source)
		const isadmin = app.user?.FeatureConfig?.['Bindings Admin']?.Enabled
		atype.subscribe(e => a.type = e.value())
		asource.subscribe(e => a.source = e.value())
		props.title = all([atype, asource]).to(([type, src]) => {
			let title = `${a.text} ${a.type}`
			if (isadmin) {
				title += `\ntypes: ${(a.types || []).join(', ')}\nsource: ${src}`
				if (a.terms) {
					title += '\nterms:\n' + a.terms.map(termToString).join('\n')
				}
			}
			return title
		})
		this.hover = reactive(false)
		this.hover.subscribe(e => {
			const related = _.compact([a.parent, ...(a.measures || []), a.groupn])
			for (const r of related) {
				const el = props.annotEls.get(r)
				if (el) el.hover.put(e.value())
			}
		})
		props.class = atype.to(type => `${props.className || ''} ${type}`)
		props.classes = /*_.transform(ENTITIES, (obj, typeKey) => {
		  obj[typeKey] = equal(atype, typeKey)
		}, */{
			highlight: this.hover,
			'is-measure': atype.to(t => ['measure', 'timepoint', 'dosage', 'quantity', 'binary-value'].includes(t))
		};//);
		['docsearch', 'local', 'user'].forEach(source => {
			props.classes[source + '-source'] = equal(asource, source)
		})
		// replace whitespace with non-breaking spaces
		// const inlineBlockize = text => {
		//   return text.replace(/\s/g, '&nbsp;')
		// }
		props.content = [
			!props.readOnly ? Icon('.annot-del.text-dark', {
				icon: deleteCircleIcon,
				classes: {
					'transparent': not(this.hover)
				},
				onclick: e => {
					e.stopPropagation()
					e.preventDefault()
					this.deleteAnnotation()
				}
			}): undefined,
			props.annot.url ? A({ href: props.annot.url, target: '_blank' }, props.annot.text) : props.annot.text
			//I('.fas.fa-bars.menu-icon')
		]
	},
	onclick(e) {
		//@ts-ignore
		// if (this.atype.valueOf() == 'unknown') {
		//   this.pop(e)
		// } else {
			console.log(this.annot)
		if (!this.annot.url) {
			e.preventDefault()
			// otherwise just mark it saved if it isn't already
			this.onAssignAnnotation?.(this.annot)
		}
		//}
	},
	onmouseenter() {
		//@ts-ignore
		this.hover.put(true)
	},
	onmouseleave() {
		//@ts-ignore
		this.hover.put(false)
	},
	// onHoverIn(a) {
	//   const related = _.compact([a.parent, ...(a.measures || []), a.groupn])
	//   for (const r of related) {
	//     const el = this.annotEls.get(r)
	//     if (el) el.hover.put(true)
	//   }
	// },
	// onHoverOut(a) {
	//   const related = _.compact([a.parent, ...(a.measures || []), a.groupn])
	//   for (const r of related) {
	//     const el = this.annotEls.get(r)
	//     if (el) el.hover.put(false)
	//   }
	// },
	deleteAnnotation() {
		this.annot.deleted = true
		this.onDeleteAnnotation(this.annot)
	},
	// saveAnnotation() {
	//   const curAnnotations = this.annotationState.valueOf()
	//   const i = curAnnotations.indexOf(this.annot)
	//   if (i == -1) {
	//     this.annotationState.push(this.annot)
	//   } else {
	//     this.annotationState.updated()
	//   }
	//   this.onAnnotationSave && this.onAnnotationSave(this.annot)
	// },
	// pop(event?) {
	//   this._dropdown || (this._dropdown = new ClassificationDropDown({
	//     atype: this.atype,
	//     asource: this.asource,
	//     onSave: () => this.saveAnnotation(),
	//     onDelete: () => this.deleteAnnotation() }))
	//   this._dropdown.show(event || { currentTarget: this.popEl })
	// }
})

export default AnnotationMark